import {Component} from '@angular/core';
import {MdSnackBar} from '@angular/material';
/**
 * \@title Basic snack-bar
 */
export class SnackBarOverviewExample {
/**
 * @param {?} snackBar
 */
constructor(public snackBar: MdSnackBar) {}
/**
 * @param {?} message
 * @param {?} action
 * @return {?}
 */
openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'snack-bar-overview-example',
  templateUrl: 'snack-bar-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: MdSnackBar, },
];
}

function SnackBarOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
SnackBarOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SnackBarOverviewExample.ctorParameters;
/** @type {?} */
SnackBarOverviewExample.prototype.snackBar;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
